import { render, staticRenderFns } from "./SellerStockTab.vue?vue&type=template&id=3e631c3e"
import script from "./SellerStockTab.vue?vue&type=script&lang=js"
export * from "./SellerStockTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports